module.exports = __webpack_public_path__ + "img/POTOSI.ffc92498.png";